import { ModalPayload } from './../../models/modal.interface';
import { Module, VuexModule, Mutation, Action } from 'vuex-module-decorators';
import { ModalOptions } from '@/models/modal.interface';

@Module
export default class ModalStore extends VuexModule {
  /* tslint:disable */
  private _opened: boolean = false;
  private _options: ModalOptions | null = { title: '', message: '', payload: null};
  private _isValidated: boolean = false;
  /* tslint:enable */

  @Mutation public setOpenedMut(payload: ModalPayload) {
    this._opened = payload.opened;
    this._options = payload.options;
    // reinitialize isValidated if modal is opened
    if (this._opened) {
      this._isValidated = false;
    }
  }

  @Mutation public validateMut(isValidated: boolean) {
    this._isValidated = isValidated;
    this._opened = false;
  }

  @Action({ commit: 'setOpenedMut' }) public openModalAction(payload: ModalOptions): ModalPayload {
    return {
      opened: true,
      options: payload,
    };
  }

  @Action({ commit: 'validateMut' }) public validateModalAction(): boolean {
    return true;
  }

  @Action({ commit: 'setOpenedMut' }) public hideModalAction(): ModalPayload {
    return { opened: false, options: null };
  }

  get isModalOpened(): boolean {
    return this._opened;
  }

  get isModalValidated(): boolean {
    return this._isValidated;
  }

  get modalPayload(): any {
    return this._options && this._options.payload;
  }

  get modalOptions(): ModalOptions | null {
    return this._options;
  }
}
